import {
  GET_MY_ADDRESSES,
  MY_ADDRESSES_ERROR,
  ADD_NEW_ADDRESS,
  REMOVE_ADDRESS,
  EDIT_ADDRESS,
} from "./types";
import axios from "axios";
import { firebase } from "../../firebase";

export const getAddresses = () => async (dispatch) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    const { data } = await axios.post(
      `${process.env.REACT_APP_apiUrl}/getAddresses`,
      {
        token,
      }
    );

    data.sort((a, b) => {
      return b.principal - a.principal;
    });
    dispatch({
      type: GET_MY_ADDRESSES,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: MY_ADDRESSES_ERROR,
      payload: error.message,
    });
  }
};

export const addNewAddress = (address) => async (dispatch) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    const { data } = await axios.post(
      `${process.env.REACT_APP_apiUrl}/postAddress`,
      {
        token,
        address,
      }
    );
    dispatch({
      type: ADD_NEW_ADDRESS,
      payload: {
        addressId: data.id,
        principal: address.principal === "true" ? true : false,
        ...address,
      },
    });
  } catch (error) {
    dispatch({
      type: MY_ADDRESSES_ERROR,
      payload: error.message,
    });
  }
};

export const editAddress = (address) => async (dispatch) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    await axios.post(`${process.env.REACT_APP_apiUrl}/editAddress`, {
      token,
      address,
    });
    dispatch({
      type: EDIT_ADDRESS,
      payload: {
        ...address,
        principal: address.principal === "true" ? true : false,
      },
    });
  } catch (error) {
    dispatch({
      type: MY_ADDRESSES_ERROR,
      payload: error.message,
    });
  }
};

export const removeAddress = (addressId) => async (dispatch) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    await axios.post(`${process.env.REACT_APP_apiUrl}/removeAddress`, {
      token,
      addressId,
    });
    dispatch({
      type: REMOVE_ADDRESS,
      payload: addressId,
    });
  } catch (error) {
    dispatch({
      type: MY_ADDRESSES_ERROR,
      payload: error.message,
    });
  }
};
